import ProgramActionTypes from "./ProgramsActionType";

export const setTabData = (tab) => ({
  type: ProgramActionTypes.SET_TAB_DATA,
  payload: tab,
});
